import React, { Component } from "react";
import xss from "xss";

import { DeleteIcon, EditIcon, CheckIcon } from "../utils/components/icons";
import { basketActions, pageActions } from "../actions";
import Price from "../type/price";
import { RAGE_RIGHT } from "../utils/enums/RAGE_RIGHT";
import PreisInfo from '../popups/PreisInfo';

// used as base class for noblemetals and currencies
export default class BasketBaseItem extends Component {
  constructor(props) {
    super(props);
    this.handleRemove = this.handleRemove.bind(this);
    this.changeDues = this.changeDues.bind(this);
    this.handleCommitDues = this.handleCommitDues.bind(this);
    this.handleEditDues = this.handleEditDues.bind(this);
  }

  state = {
    orderjson: {},
    itemAmount: this.props.item.amount,
    gebuehr: this.props.item.positionDues.clone().toFormat(),
    editDues: false,
    showErrorMsg: false,
    errorMsg: "",
    denominator: false,
    windowPosition: null
  };

  handleRemove() {
    this.props.dispatch(basketActions.removeItem(this.props.item));
    if (this.props.basketStorage.numItems() === 0) {
      this.props.dispatch(pageActions.setOverviewPage());
    }
  }

  changeDues(e) {
    e.preventDefault();
    let due = xss(e.target.value);
    if (this.state.editDues && this.props.configStorage.isMaShop()) {
      this.setState({ gebuehr: due });
    }
  }

  validateDue(num) {
    let due = Price.create(num);
    let item = this.getItemPrice();
    let difference = this.props.configStorage.isAnkaufShop()
      ? item.subtract(due).getPrice()
      : item.add(due).getPrice();
    if (difference >= 0) {
      this.setState({ showErrorMsg: false, errorMsg: "" });
      return true;
    } else {
      this.setState({ showErrorMsg: true, errorMsg: "Eingabe invalide" });
      return false;
    }
  }

  resetDues() {
    // due is undefined;
    this.props.item.changedDue = undefined;
    this.setState({ gebuehr: this.props.item.positionDues.clone().toFormat() });
  }

  handleEditDues(e) {
    e.preventDefault();
    this.setState({
      gebuehr: this.props.item.positionDues.clone().toFormat(),
      editDues: true,
      isBezahlButtonClicked: false
    });
    this.props.onEdit(this.props.index, true);
  }

  handleCommitDues(e) {
    e.preventDefault();
    this.props.onEdit(this.props.index, false);
    let due = this.state.gebuehr;
    if (due === "") {
      this.resetDues();
      // return;
    } else {
      due = due.replace('.', '').replace(',', '.');
    }
    if (this.validateDue(due)) {
      due = Price.create(due);
      this.props.dispatch(basketActions.changeDues(this.props.item, due));
      this.setState({ editDues: false });
    };
  }

  renderEditIcons() {
    if (
      !this.props.rightStorage.currentRight.includes(RAGE_RIGHT.RAGE_BERATER_ZWEI) ||
      !this.props.basketStorage.editCondition ||
      this.props.configStorage.isKundenShop() ||
      (typeof this.props.basketStorage.isDuesEditable === 'function' && !this.props.basketStorage.isDuesEditable(this.props.item))) {
      return null;
    }
    if (!this.state.editDues) {
      return <button type="button" className="btn btn-link" onClick={this.handleEditDues} aria-label="Kondition editieren"><EditIcon /></button>;
    } else {
      return <button type="button" className="btn btn-link" onClick={this.handleCommitDues} aria-label="Kondition übernehmen"><CheckIcon /></button>;
    }
  }

  renderKonditionChange() {
    let config = this.props.configStorage;
    let gebuehr = this.props.item.positionDues.clone().toFormat();
    return <td className="text-end redOnDirty" aria-label="Konditionsänderung">
      <div>
        <div className="ser-condition">
          <input
            name="condition"
            value={this.state.editDues ? this.state.gebuehr : gebuehr}
            onChange={this.changeDues}
            className={"ser-input text-end w-three bg-transparent" +
              (!this.state.editDues ? " border-0" : "") +
              (!config.isMaShop() ? " text-dark" : "")
            }
            disabled={!this.state.editDues}
            type="text"
            aria-label="Kondition"
          />
          &nbsp;EUR
          {this.renderEditIcons()}
        </div>
        {this.state.editDues && this.props.isBezahlButtonClicked ? (
          <p className="ui error message text-danger">Hinweis: Konditions&shy;anpassung muss bestätigt werden!</p>) : ""
        }
        {this.state.showErrorMsg
          ? (
            <div className="ui error message text-danger">
              {this.state.errorMsg}
            </div>
          )
          : null
        }
      </div>
    </td>;
  }

  renderItem() {
    console.log("renderItem() must be overwriten by child class");
  }

  render() {
    let basketStorage = this.props.basketStorage || {};
    let item = this.props.item;
    let isDirty = item.dirty ? "align-middle dirty" : "align-middle";
    return (
      <tr
        className={isDirty}
      >
        {this.renderItem()}
        <td className="button-table" aria-label="Aktionen">
          {basketStorage.locked ? null : (
            <button type="button"
              onClick={this.handleRemove}
              className="btn text-danger bg-transparent"
              aria-label={item.name + " löschen"}
            >
              <DeleteIcon />
            </button>
          )}
          <PreisInfo item={item} gebuehr={this.state.editDues ? this.state.gebuehr : item.positionDues.clone().toFormat()} />
        </td>
      </tr>
    );
  }
}
